import React from "react";
import clsx from "clsx";

const Card = ({ children }) => <div className={clsx("card", !children[2] && "no-action")}>{children}</div>;

export default Card;
